import Icon from '@/components/UI/icon/Icon';
import { IconNames } from '@/components/UI/Types';
import Typography from '@/components/UI/typography/Typography';
import Box from '@/components/UI/box/Box';
import styles from './ReviewRateItem.module.scss';
interface ReviewRateItemType {
  icon: IconNames;
  title: string;
  rate: number;
}
const ReviewRateItem = ({
  icon,
  title,
  rate
}: ReviewRateItemType) => {
  return <Box className={styles['review-rate-item']} data-sentry-element="Box" data-sentry-component="ReviewRateItem" data-sentry-source-file="ReviewRateItem.tsx">
      <Box className={styles['icon-wrapper']} data-sentry-element="Box" data-sentry-source-file="ReviewRateItem.tsx">
        <Icon name={icon} type={'highEmphasis'} size="small" data-sentry-element="Icon" data-sentry-source-file="ReviewRateItem.tsx" />
      </Box>
      <Typography variant="bodyS" color={'neutral_main'} data-sentry-element="Typography" data-sentry-source-file="ReviewRateItem.tsx">
        {title}
      </Typography>
      <Typography variant="bodyM_Bold" data-sentry-element="Typography" data-sentry-source-file="ReviewRateItem.tsx">
        {rate}{' '}
        <Typography variant="bodyS" className={styles['rate-text']} data-sentry-element="Typography" data-sentry-source-file="ReviewRateItem.tsx">
          از 5
        </Typography>
      </Typography>
    </Box>;
};
export default ReviewRateItem;